import { lazy } from "react";

// project imports
import MinimalLayout from "../theme/layout/MinimalLayout";
import Loadable from "../theme/widgets/Loadable";
import PaymentSuccess from "../pages/session/payment/PaymentSuccess";
import PaymentCancelled from "../pages/session/payment/PaymentCancelled";
import PaymentVariable from "../pages/session/payment/PaymentVariable";

// login option 3 routing
const AuthLogin = Loadable(
  lazy(() => import("../pages/session/authentication/Login"))
);

const AuthForgottenPassword = Loadable(
  lazy(() => import("../pages/session/authentication/Forgottenpassword"))
);

const Register = Loadable(
  lazy(() => import("../pages/session/authentication/Register"))
);

const AuthRegisterConfirm = Loadable(
  lazy(() => import("../pages/session/auth-forms/AuthRegisterConfirm"))
);

const LoginExternal = Loadable(
  lazy(() => import("../pages/session/authentication/LoginExternal"))
);

//const AuthRegister = Loadable(lazy(() => import('../pages/session/authentication/Register')));
const CleverRedirect = Loadable(
  lazy(() => import("../pages/session/CleverRedirect"))
);
const OauthCallback = Loadable(
  lazy(() => import("../pages/session/authentication/OauthCallback"))
);



// ==============================|| AUTHENTICATION ROUTING ||============================== //

const AuthenticationRoutes = {
  path: "/",
  element: <MinimalLayout />,
  children: [ 
    { path: "/login", element: <AuthLogin /> },
    { path: "/forgottenpassword", element: <AuthForgottenPassword /> },
    { path: "/loginExternal", element: <LoginExternal /> },
    { path: "/register", element: <Register /> },
    { path: "/registerConfirm", element: <AuthRegisterConfirm /> },
    { path: "/clever", element: <CleverRedirect /> },
    { path: "/oauth/callback", element: <OauthCallback /> },
    { path: "/payment-success", element: <PaymentSuccess /> },
    { path: "/payment-cancelled", element: <PaymentCancelled /> },
    { path: "/payment-entry", element: <PaymentVariable /> },
    //{ path: '/register', element: <AuthRegister /> }
  ],
};

export default AuthenticationRoutes;
